import type { TFunction } from 'i18next';
import type { DataGridColumnOptionsProps } from '../../components/DataGridControl/DataGridControl';

import {
  dateRenderer,
  defaultRenderer,
  pillRenderer,
} from '../../components/DataGrid/DataGridCell/cellRenderer';

import { ArrowUpRightIcon } from '../../images/shapes';

export const getDefinedColumns = (
  gridOptionsByID: Record<string, DataGridColumnOptionsProps> | undefined,
  hiddenColumnsById: Record<string, boolean | undefined>,
  t: TFunction,
) => ({
  id: {
    accessor: 'id',
    label: 'ID',
    width: gridOptionsByID?.['id']?.width,
    render: (data: string) => defaultRenderer(data),
    sortable: true,
    filterInputType: 'text',
    resizable: true,
    removable: true,
    hide: hiddenColumnsById.id,
  },
  name: {
    accessor: 'name',
    label: t('Global.Name'),
    width: gridOptionsByID?.['name']?.width,
    render: (data: string) => defaultRenderer(data),
    sortable: true,
    filterInputType: 'text',
    resizable: true,
    removable: true,
    hide: hiddenColumnsById.name,
  },
  slug: {
    accessor: 'slug',
    label: 'Slug',
    width: gridOptionsByID?.['slug']?.width,
    render: (data: string) => defaultRenderer(data),
    sortable: true,
    filterInputType: 'text',
    resizable: true,
    removable: true,
    hide: hiddenColumnsById.slug,
  },
  'organization.name': {
    accessor: 'organization.name',
    label: t('Users.Organization'),
    width: gridOptionsByID?.['organization.name']?.width,
    render: (data: string) => defaultRenderer(data),
    sortable: true,
    filterInputType: 'text',
    resizable: true,
    removable: true,
    hide: hiddenColumnsById['organization.name'],
  },
  'organization.id': {
    accessor: 'organization.id',
    label: t('Users.OrganizationId'),
    width: gridOptionsByID?.['organization.id']?.width,
    render: (data: string) => defaultRenderer(data),
    sortable: true,
    filterInputType: 'text',
    resizable: true,
    removable: true,
    hide: hiddenColumnsById['organization.id'],
  },
  planName: {
    accessor: 'planName',
    label: t('Plans.Name'),
    width: gridOptionsByID?.['planName']?.width,
    render: (data: string) => defaultRenderer(data),
    sortable: true,
    filterInputType: 'text',
    resizable: true,
    removable: true,
    hide: hiddenColumnsById['planName'],
  },
  paymentStatus: {
    accessor: 'paymentStatus',
    label: t('Users.PaymentStatus'),
    width: gridOptionsByID?.['paymentStatus']?.width,
    render: (data: string) => pillRenderer(data),
    sortable: true,
    filterInputType: 'select',
    filterInputOptions: ['paid', 'non-paid', 'trial'],
    resizable: true,
    removable: true,
    hide: hiddenColumnsById['paymentStatus'],
  },
  paymentInterval: {
    accessor: 'paymentInterval',
    label: t('Users.PaymentInterval'),
    width: gridOptionsByID?.['paymentInterval']?.width,
    render: (data: string) => pillRenderer(data),
    sortable: true,
    filterInputType: 'select',
    filterInputOptions: ['month', 'year'],
    resizable: true,
    removable: true,
    hide: hiddenColumnsById['paymentInterval'],
  },
  paymentDueDate: {
    accessor: 'paymentDueDate',
    label: t('Users.PaymentDueDate'),
    width: gridOptionsByID?.['paymentDueDate']?.width,
    render: (data: string) => dateRenderer(data),
    sortable: true,
    filterInputType: 'text',
    resizable: true,
    removable: true,
    hide: hiddenColumnsById['paymentDueDate'],
  },
  subscriptionId: {
    accessor: 'subscriptionId',
    label: t('Spaces.SubscriptionId'),
    width: gridOptionsByID?.['subscriptionId']?.width,
    render: (data: string) =>
      defaultRenderer(
        data ? (
          <>
            <ArrowUpRightIcon className="inline-block w-3 mr-2" />
            <span className="group-hover:underline">{data}</span>
          </>
        ) : null,
      ),
    sortable: true,
    filterInputType: 'text',
    resizable: true,
    removable: true,
    hide: hiddenColumnsById['paymentClientId'],
  },
  createdAt: {
    accessor: 'createdAt',
    label: t('ObjectsOfType.Created'),
    width: gridOptionsByID?.['createdAt']?.width,
    render: (data: string) => dateRenderer(data),
    sortable: true,
    resizable: true,
    removable: true,
    hide: hiddenColumnsById.createdAt,
  },
});
